import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-grabber",
  templateUrl: "./med-icon-grabber.component.html",
})
export class MedIconGrabberComponent extends SvgMixinComponent {}
